import { useHookstate } from "@hookstate/core";
import { FormControlLabel, Checkbox } from "@mui/material";
import { SITEID_GLOBAL_STATE } from "globalStore/globalStore";
import { useDispatch, useSelector } from "react-redux";
import { StyledCheckbox } from "./CheckboxStyled";
import { COMMON_SERVICES } from "../../../redux/reduxToolkitServices/_commonServices/commonServices";
import React, { useState, useEffect } from "react";
import { CheckIcon, UncheckIcon } from "assets/svgIcons";
import { useTranslation } from "react-i18next";

export const AllowFreeTextMessageCheckbox = ({
  identification,
  disableState,
}) => {
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { siteSettingsData } = useSelector((state) => state.commonReducers);
  const [freeTextMessages, setFreeTextMessages] = useState(false);

  useEffect(() => {
    if (siteSettingsData && Object.keys(siteSettingsData).length !== 0) {
      setFreeTextMessages(siteSettingsData?.FreeformMessagesEnabled);
    }
  }, [siteSettingsData]);

  const handleCheckboxValue = (e, identification) => {
    if (identification === "FT") {
      dispatch(
        COMMON_SERVICES.putFleetSettingsServices2({
          value: e.target.checked,
          code: identification,
        },siteId.get())
      ).then(() => {
        dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
      });

      setFreeTextMessages(e.target.checked);
    }
  };

  return (
    <StyledCheckbox className="checkbox">
      <FormControlLabel
        control={
          <Checkbox
            icon={<UncheckIcon width={20} height={20} />}
            checkedIcon={<CheckIcon width={20} height={20} />}
            disabled={disableState}
            checked={freeTextMessages}
            onChange={(e) => handleCheckboxValue(e, identification)}
          />
        }
        label={t("Allow_free_text_messages")}
      />
    </StyledCheckbox>
  );
};
